
import { Component, Mixins } from 'vue-property-decorator';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component({})
export default class TheContent extends Mixins(DarkThemeInfoMixin) {
}
